import {AxiosResponse} from 'axios';
import {useState} from 'react';
import usePostCheckOrderOtp from '../../../../../services/hookService/postCheckOrderOtp/usePostCheckOrderOtp';
import usePostCheckStoreOderOtp from '../../../../../services/hookService/postCheckStoreOderOtp/usePostCheckStoreOderOtp';
import {
  PaymentMethodChoices,
  TransactionTypesChoices,
} from '../../../../shopping-basket/cash-payment/utils/helpers';

export function usePostCheckOtpCodeOrders({
  transactionType,
  paymentType,
  orderGuid,
  storeOrderGuid,
  enabled = false,
  handleAfterSuccess,
  handleOnError,
}: {
  transactionType?: TransactionTypesChoices;
  paymentType?: PaymentMethodChoices;
  orderGuid?: string;
  storeOrderGuid?: string;
  enabled?: boolean;
  handleAfterSuccess?: (status: number) => void;
  handleOnError?: (status: number | null) => void;
}) {
  const [response, setResponse] = useState<AxiosResponse<any> | null>(null);

  const orderOtpMutation = usePostCheckOrderOtp((res: AxiosResponse<any>) => {
    setResponse(res);
    handleAfterSuccess?.(res.status);
  }, handleOnError);

  const storeOrderOtpMutation = usePostCheckStoreOderOtp(
    (res: AxiosResponse<any>) => {
      setResponse(res);
      handleAfterSuccess?.(res.status);
    },
    handleOnError,
  );

  const emptyMutation = {
    mutate: (_: any) => {},
    isLoading: false,
  };

  let activeMutation = emptyMutation;

  switch (transactionType) {
    case TransactionTypesChoices.ORDER:
      activeMutation = orderOtpMutation;
      break;

    case TransactionTypesChoices.STORE_ORDER:
      activeMutation = storeOrderOtpMutation;
      break;

    default:
      activeMutation = emptyMutation;
  }

  const mutate = (code: string) => {
    if (!enabled) return;

    if (transactionType === TransactionTypesChoices.ORDER && orderGuid) {
      activeMutation.mutate({
        code,
        order: orderGuid,
        payment_type: paymentType,
      });
    }

    if (
      transactionType === TransactionTypesChoices.STORE_ORDER &&
      storeOrderGuid
    ) {
      activeMutation.mutate({
        code,
        store_order: storeOrderGuid,
        payment_type: paymentType,
      });
    }
  };

  return {
    mutate,
    response,
    isLoading: activeMutation.isLoading,
    hasValidConfig:
      Boolean(transactionType) &&
      (Boolean(orderGuid) || Boolean(storeOrderGuid)),
  };
}
